export class I18n {
    _id: string;
    name: string;
    iso: string;
    locale: string;
    created_at: string;
    updated_at: string;
}